module.exports = __webpack_public_path__ + "img/milan2.56ff5849.jpg";